"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSNSPublishInput = exports.parseSNSRecordMesssage = exports.IOTV_SNSAttributeMapToMap = exports.IOTV_SNS_MOCK_OUTPUT_ObjectToMessageAttributeMap = exports.IOTV_SNSPublishInputToMessageAttributeMap = exports.IOTV_Thing_EventType = exports.IOTV_Notifiable_EventType = exports.IOTV_Alert_Trigger_EventType = void 0;
const debug = false;
var IOTV_Alert_Trigger_EventType;
(function (IOTV_Alert_Trigger_EventType) {
    IOTV_Alert_Trigger_EventType["ALERT"] = "ALERT";
    IOTV_Alert_Trigger_EventType["OPEN_ALERT"] = "OPEN_ALERT";
    IOTV_Alert_Trigger_EventType["UPDATE_ALERT"] = "UPDATE_ALERT";
    IOTV_Alert_Trigger_EventType["CANCEL_ALERT"] = "CANCEL_ALERT";
})(IOTV_Alert_Trigger_EventType || (exports.IOTV_Alert_Trigger_EventType = IOTV_Alert_Trigger_EventType = {}));
var IOTV_Notifiable_EventType;
(function (IOTV_Notifiable_EventType) {
    IOTV_Notifiable_EventType["INCIDENT_OPENED"] = "INCIDENT_OPENED";
    IOTV_Notifiable_EventType["INCIDENT_UPDATED"] = "INCIDENT_UPDATED";
    IOTV_Notifiable_EventType["INCIDENT_CLOSED"] = "INCIDENT_CLOSED";
})(IOTV_Notifiable_EventType || (exports.IOTV_Notifiable_EventType = IOTV_Notifiable_EventType = {}));
var IOTV_Thing_EventType;
(function (IOTV_Thing_EventType) {
    IOTV_Thing_EventType["FILL_EVENT"] = "FILL_EVENT";
})(IOTV_Thing_EventType || (exports.IOTV_Thing_EventType = IOTV_Thing_EventType = {}));
/** converts a single level object to SNS Message Attributes */
const IOTV_SNSPublishInputToMessageAttributeMap = (ob) => {
    const messageAttributes = {};
    Object.entries(ob).forEach(([k, v]) => {
        if (typeof v === 'string') {
            messageAttributes[k] = {
                DataType: 'String',
                StringValue: v,
            };
        }
        else if (typeof v === 'number') {
            messageAttributes[k] = {
                DataType: 'Number',
                StringValue: v.toString(),
            };
        }
        else if (typeof v === 'boolean') {
            messageAttributes[k] = {
                DataType: 'Boolean',
                StringValue: v.toString(),
            };
        }
        else {
            debug && console.log(`${k} with value ${v} not supported yet, only doing strings, booleans, numbers`);
        }
    });
    return messageAttributes;
};
exports.IOTV_SNSPublishInputToMessageAttributeMap = IOTV_SNSPublishInputToMessageAttributeMap;
const IOTV_SNS_MOCK_OUTPUT_ObjectToMessageAttributeMap = (ob) => {
    const messageAttributes = {};
    Object.entries(ob).forEach(([k, v]) => {
        if (typeof v === 'string') {
            messageAttributes[k] = {
                Type: 'String',
                Value: v,
            };
        }
        else if (typeof v === 'number') {
            messageAttributes[k] = {
                Type: 'Number',
                Value: v.toString(),
            };
        }
        else if (typeof v === 'boolean') {
            messageAttributes[k] = {
                Type: 'Boolean',
                Value: v.toString(),
            };
        }
        else {
            debug && console.log(`${k} with value ${v} not supported yet, only doing strings, booleans, numbers`);
        }
    });
    return messageAttributes;
};
exports.IOTV_SNS_MOCK_OUTPUT_ObjectToMessageAttributeMap = IOTV_SNS_MOCK_OUTPUT_ObjectToMessageAttributeMap;
const IOTV_SNSAttributeMapToMap = (messageAttributes) => {
    const map = {};
    Object.entries(messageAttributes).forEach(([k, v]) => {
        if (v.Type === 'String') {
            map[k] = v.Value;
        }
        else if (v.Type === 'Number') {
            map[k] = parseFloat(v.Value);
        }
        else if (v.Type === 'Boolean') {
            map[k] = v.Value === 'true';
        }
        else if (v.Value) {
            debug && console.log(`${k} with type ${typeof v} value ${v} not supported yet, only doing strings, booleans, numbers`);
        }
        else {
            debug && console.log(`${k} with type ${typeof v} value ${v} could not be processed`);
        }
    });
    return map;
};
exports.IOTV_SNSAttributeMapToMap = IOTV_SNSAttributeMapToMap;
const parseSNSRecordMesssage = (record) => {
    let object = undefined;
    try {
        object = JSON.parse(record.Sns.Message);
    }
    catch (e) {
        console.log('WARN: unable to parse string', record.Sns.Message);
    }
    return object;
};
exports.parseSNSRecordMesssage = parseSNSRecordMesssage;
const getSNSPublishInput = (deviceControlMessageObject) => {
    const publishInput = {
        ...deviceControlMessageObject,
        MessageAttributes: (0, exports.IOTV_SNSPublishInputToMessageAttributeMap)(deviceControlMessageObject.MessageAttributes),
        Message: JSON.stringify(deviceControlMessageObject.Message),
    };
    return publishInput;
};
exports.getSNSPublishInput = getSNSPublishInput;
